var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.1047,
    cy: 17.1818,
    rx: 1.04762,
    ry: 1.06061,
    fill: "#F41F2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1048 8.27273V10.8182V14M17.0638 21H4.98001C2.71992 21 1.27147 18.5956 2.32798 16.5976L8.42742 5.06308C9.55883 2.92349 12.6278 2.93551 13.7424 5.08389L19.7267 16.6184C20.7628 18.6154 19.3136 21 17.0638 21Z",
    stroke: "#F41F2B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.22aa8b88dc6153d0db239ca7b58ccf75.svg";
export { ForwardRef as ReactComponent };